export const HANDLED_APPLICATION_ERROR = 'HANDLED_APP_ERROR'
export const DISSECTED_ERROR = 'DISSECTED_ERROR'
